import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const SITE_URL = import.meta.env.VITE_SITE_URL;

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  'name': 'Política de Privacidade - CSSBuySpreadsheet.asia',
  'description': 'Política de privacidade do CSSBuySpreadsheet.asia. Saiba como protegemos seus dados ao usar o melhor CSSBuy Spreadsheet 2026.',
  'url': `${SITE_URL}/politica-privacidade`,
  'inLanguage': 'pt',
  'isPartOf': {
    '@type': 'WebSite',
    'name': 'CSSBuy Spreadsheet',
    'url': SITE_URL,
  },
};

const breadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  'itemListElement': [
    {
      '@type': 'ListItem',
      'position': 1,
      'name': 'CSSBuy Spreadsheet',
      'item': SITE_URL,
    },
    {
      '@type': 'ListItem',
      'position': 2,
      'name': 'Política de Privacidade',
      'item': `${SITE_URL}/politica-privacidade`,
    },
  ],
};

export default function PoliticaPrivacidade() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <JsonLd data={webPageSchema} />
      <JsonLd data={breadcrumbSchema} />
      <Navbar />
      <main>
        <article className="w-full pt-24 pb-14 md:pt-28 md:pb-20">
          <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
            <div className="mb-8">
              <Link
                to="/"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200"
              >
                <i className="ri-arrow-left-line text-base"></i>
                Voltar ao Início
              </Link>
            </div>

            <h1 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-8">
              Política de Privacidade
            </h1>

            <div className="space-y-5 text-foreground-700 leading-relaxed text-sm md:text-base">
              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">1. Informações Gerais</h2>
              <p>
                O <strong>CSSBuySpreadsheet.asia</strong> está comprometido com a proteção da privacidade 
                dos seus visitantes. Esta Política de Privacidade explica como coletamos, usamos e protegemos 
                suas informações quando você utiliza nosso site sobre o <strong>CSSBuy Spreadsheet</strong>.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">2. Dados Coletados</h2>
              <p>
                Nosso site sobre o <strong>CSSBuy Spreadsheet 2026</strong> pode coletar automaticamente 
                informações não pessoais, como tipo de navegador, idioma, data e hora de acesso e páginas 
                visitadas. Estas informações são utilizadas exclusivamente para melhorar a experiência de 
                navegação e o conteúdo do <strong>melhor CSSBuy Spreadsheet</strong>.
              </p>
              <p>
                Não coletamos informações pessoais identificáveis sem o seu consentimento explícito. Caso 
                você entre em contato conosco via email, utilizaremos suas informações apenas para responder 
                à sua solicitação.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">3. Cookies</h2>
              <p>
                O <strong>CSSBuySpreadsheet.asia</strong> pode utilizar cookies para melhorar a experiência 
                de navegação. Cookies são pequenos arquivos de texto armazenados no seu dispositivo que 
                ajudam a lembrar preferências e analisar o tráfego do site.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">4. Links Externos</h2>
              <p>
                Nosso site contém links para sites externos, incluindo o <strong>CSSBuy Sheet</strong> 
                principal. Não nos responsabilizamos pelas práticas de privacidade destes sites. Recomendamos 
                que você leia as políticas de privacidade de cada site visitado.
              </p>

              <h2 className="font-heading text-xl font-semibold text-foreground-950 mt-6 mb-3">5. Contato</h2>
              <p>
                Para dúvidas sobre esta política, entre em 
                <Link to="/contato" className="text-primary-600 hover:text-primary-700 underline"> contato conosco</Link>.
              </p>

              <p className="text-xs text-foreground-500 mt-8">
                Última atualização: Junho de 2026
              </p>
            </div>
          </div>
        </article>
      </main>
      <Footer />
    </>
  );
}